import React from 'react';
import styled from 'styled-components';

const Card = styled.article`
  border-radius: 28px;
  padding: 24px;
  background: rgba(20, 22, 35, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.04);
  box-shadow: 0 20px 60px rgba(4, 8, 20, 0.55);
  display: flex;
  flex-direction: column;
  gap: 16px;
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease;
  &:hover {
    transform: translateY(-6px);
    border-color: rgba(133, 76, 230, 0.4);
  }
`;

const Thumbnail = styled.img`
  width: 100%;
  height: 180px;
  border-radius: 18px;
  object-fit: cover;
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Tag = styled.span`
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  background: rgba(133, 76, 230, 0.12);
  color: ${({ theme }) => theme.text_primary};
`;

const Title = styled.h3`
  margin: 0;
  font-size: 20px;
  color: ${({ theme }) => theme.text_primary};
`;

const Meta = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.text_secondary};
  font-size: 14px;
`;

const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.text_secondary};
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const AvatarStack = styled.div`
  display: flex;
`;

const Avatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.bg};
  margin-left: -8px;
  &:first-child {
    margin-left: 0;
  }
`;

const ViewButton = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.primary};
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const ProjectCards = ({ project, setOpenModal }) => (
  <Card onClick={() => setOpenModal({ state: true, project })}>
    <Thumbnail src={project.image} alt={project.title} />
    <Tags>
      {project.tags?.map((tag) => (
        <Tag key={tag}>{tag}</Tag>
      ))}
    </Tags>
    <Title>{project.title}</Title>
    <Meta>
      <span>{project.date}</span>
      <span>{project.category}</span>
    </Meta>
    <Description>{project.description}</Description>
    <CardFooter>
      <AvatarStack>
        {project.member?.map((member, index) => (
          <Avatar
            key={member.img || `${project.title}-${index}`}
            src={member.img}
            alt={member.name || 'project collaborator'}
          />
        ))}
      </AvatarStack>
      <ViewButton>
        View story
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path
            d="M5 12h14M13 6l6 6-6 6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </ViewButton>
    </CardFooter>
  </Card>
);

export default ProjectCards;